import { IsEnum, IsNotEmpty, IsString } from 'class-validator';
import { UserTwoFATokenVaultActions } from './token-vault-actions.enum';

export class UserActionTokenDto {
  @IsEnum(UserTwoFATokenVaultActions)
  @IsNotEmpty()
  action!: UserTwoFATokenVaultActions;

  @IsString()
  @IsNotEmpty()
  token!: string;
}
